import React, { useContext, useState } from 'react'
import { Formik, Form as FormikForm, useFormikContext } from 'formik'
import Box from '@material-ui/core/Box'
import isEmpty from 'lodash/isEmpty'
import get from 'lodash/get'

import { R, sumCurrency } from '../../../../../utils/currency'
import { FnaContext } from '../../../context'
import { CardContent } from '../../../../../components/layout/Card'
import { buildInitialValues } from './initialValues'
import { setupValidationSchema } from './validations'
import { NumberFieldWithLabel } from '../../../../../components/Form/Fields'
import { Button } from '../../../../../components/Button'
import { Spotlight } from '../../../../../components/Spotlight'
import { Aside } from '../../../Components/Form/Aside'
import { ASIDE_VIEWS } from '../../../reducer'

import { ASSESSMENT_TYPE, FORM_ACTIONS } from '../../../reducer'

// TODO: Current form has no mobile designs
export const Form = () => {
  const { actions: { submit } } = useContext(FnaContext)
  const [asideView, setAsideView] = useState(false)

  return (
    <CardContent>
      <Formik
        onSubmit={(values) => submit(values, ASSESSMENT_TYPE.INCOME_PROTECTION)}
        initialValues={buildInitialValues()}
        validationSchema={setupValidationSchema()}
        render={({ values }) => (
          <FormikForm>
            <FormSpotlights values={values} />
            <div className='grid grid-cols-2'>
              <Main
                setAsideView={setAsideView}
              />
              <Aside
                asideView={asideView}
              />
            </div>
          </FormikForm>
        )}
      />
    </CardContent>
  )
}

const Main = ({ setAsideView }) => {
  const { values, isValid, isSubmitting } = useFormikContext()
  const {
    state: {
      formAction,
      assets,
      riskProducts,
      loading
    },
    actions: { goToIndex, goToDelete }
  } = useContext(FnaContext)

  const assetsExist = !isEmpty(assets)
  const newForm = formAction === FORM_ACTIONS.CREATE
  const riskProductsExist = !isEmpty(riskProducts)

  return (
    <div className='app-form'>
      <h3>Things to pay for over time</h3>
      <NumberFieldWithLabel
        label='Monthly budget'
        name='monthly_budget_expenses'
      />
      <Box
        className='flex items-end justify-between mr-4'
      >
        <NumberFieldWithLabel
          readOnly
          value={get(values, 'total_asset_monthly_contributions', 0)}
          style={{ flex: 2 }}
          label='Total asset monthly contributions'
          name='total_asset_monthly_contributions'
        />
        <Button
          trackAs="Income protection: Select assets"
          style={{ flex: 1 }}
          disabled={!assetsExist}
          primary onClick={() => {
            setAsideView(ASIDE_VIEWS.ASSETS)
          }}>Select Assets</Button>
      </Box>
      {!assetsExist && <small className='ml-4 mb-2'>You do not have any assets</small>}

      <h3>Existing income protection cover</h3>
      <Box
        className='flex items-end justify-between mr-4'
      >
        <NumberFieldWithLabel
          readOnly
          value={get(values, 'total_from_selected_risk_products', 0)}
          style={{ flex: 2 }}
          label='Total risk cover value'
          name='total_from_selected_risk_products'
        />
        <Button
          trackAs="Income protection: Select income cover products"
          style={{ flex: 1 }}
          disabled={!riskProductsExist}
          primary onClick={() => {
            setAsideView(ASIDE_VIEWS.RISK_PRODUCTS)
          }}>Select income cover products</Button>
      </Box>
      {!riskProductsExist && <small className='ml-4 mb-2'>You do not have any income cover</small>}
      <NumberFieldWithLabel
        label='Total monthly cover value'
        name='existing_cover'
      />

      <Box className='grid grid-cols-2 gap-4 mt-4'>
        <Button secondary onClick={goToIndex}>Go Back</Button>
        <Button
          trackAs="Income protection: Complete assessment"
          disabled={!isValid || isSubmitting || loading} primary type='submit'
        >
          {loading ? "Calculating..." : "Calculate"}
        </Button>
        {!newForm &&
          <Button
            disabled={loading}
            trackAs="Income protection: Delete" tertiary onClick={goToDelete(ASSESSMENT_TYPE.INCOME_PROTECTION)}
            className="button col-span-2"
          >
            Delete assessment
          </Button>
        }
      </Box>
    </div>
  )
}

const FormSpotlights = ({ values }) => {
  return (
    <Box
      className='flex justify-between px-12 my-4'
    >
      <Spotlight
        value={R(get(values, 'existing_cover', 0)).format()}
        description={`Existing cover`} />
      <Spotlight
        value={sumCurrency([get(values, 'total_asset_monthly_contributions', 0), get(values, 'monthly_budget_expenses', 0)]).format()}
        description={`Required cover`} />
    </Box>
  )
}
